import "./LiveBadge.css";

interface LiveBadgeProps {
	/** Number of Premier League matches currently in play. */
	matchesLive: number;
	/** Countdown to the next refresh while matches are live. */
	secondsToNextFetch?: number;
	/** True while the gameweek is open but nothing is being played. */
	waiting?: boolean;
}

export const LiveBadge = ({ matchesLive, secondsToNextFetch, waiting }: LiveBadgeProps) => {
	if (waiting) {
		return (
			<div className="live-badge live-badge-idle" title="Gameweek open, no matches in play">
				GW OPEN
			</div>
		);
	}
	return (
		<div className="live-badge" title={secondsToNextFetch != null ? `Refreshing in ${secondsToNextFetch}s` : undefined}>
			<span className="live-dot" />
			LIVE · {matchesLive}
		</div>
	);
};
